<template>
    <div class="main">
        <el-dialog
            title="查看"
            :visible.sync="openData.state"
            :close-on-click-modal="false"
            width="800px"
            @close="dialogVisibleClone"
        >
            <div class="name-per">
                <div
                v-for="(item, index) in titleList"
                :key="index"
                class="name-list"
                @click="changeIdx(item.id)"
                >
                <div>
                    <div
                    class="name-title"
                    :class="{
                        changeColor: controlAddContent == item.id,
                    }"
                    >
                    <div></div>
                    <div><i class="el-icon-circle-check"></i></div>
                    <div></div>
                    </div>
                    <div class="name-bottom">{{ item.name }}</div>
                </div>
                </div>
            </div>
            <el-form
                ref="addformRef"
                :model="formData"
                label-width="100px"
                disabled
            >
                <div v-show="controlAddContent == 1" style="margin-top: 20px">
                    <div style="display:flex;">
                        <div style="width:50%;">
                            <el-form-item label="姓名:">
                                <el-input v-model="formData.name" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="性别:" prop="gender">
                                <el-select placeholder="根据身份证号获取" v-model="formData.gender" style="width: 100%">
                                    <el-option value="0" label="男"></el-option>
                                    <el-option value="1" label="女"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="身份证号:" prop="idCard">
                                <el-input placeholder="请输入" v-model="formData.idCard"></el-input>
                            </el-form-item>
                            <el-form-item label="年龄:">
                                <el-input placeholder="获取数据" v-model="formData.age"></el-input>
                            </el-form-item>
                            <el-form-item label="出生日期:">
                                <el-input placeholder="获取数据" v-model="formData.birth"></el-input>
                            </el-form-item>
                        </div>
                        <div style="width:30%;padding-left:20%;padding-top:10px;">
                            <el-upload
                                ref="uploadAvatar"
                                class="avatar-uploader"
                                style=""
                                :action="actionUrl"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload"
                            >
                                <img
                                v-if="formData.portraitImg"
                                :src="formData.portraitImg"
                                class="avatar"
                                />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </div>
                    </div>
                    <div style="display: flex">
                        <el-form-item label="手机号码" prop="phone" style="width:50%">
                            <el-input placeholder="请输入" v-model="formData.phone" style="width: 100%"></el-input>
                        </el-form-item>
                        <el-form-item label="类型" prop="personType" style="width:50%">
                            <el-input v-model="formData.personTypeName"></el-input>
                        </el-form-item>
                    </div>
                    <div class="addressFrom">
                    <div class="addressTitle"><span>*</span> 户籍地址:</div>
                    <div class="addressContent">
                        <div class="addressBox">
                            <div class="addressItem">
                            <el-form-item prop="shengId">
                                <el-select
                                disabled
                                v-model="formData.shengId"
                                placeholder="请选择省"
                                @change="handleProvince"
                                ref="selectShengChange"
                                >
                                <el-option
                                    v-for="(item, index) in provinceList"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.adcode"
                                >
                                </el-option>
                                </el-select>
                            </el-form-item>
                            </div>
                            <div class="addressItem">
                            <el-form-item prop="shiId">
                                <el-select
                                disabled
                                v-model="formData.shiId"
                                placeholder="请选择市"
                                @change="handleCity"
                                ref="selectShiChange"
                                >
                                <el-option
                                    v-for="(item, index) in cityList"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.adcode"
                                >
                                </el-option>
                                </el-select>
                            </el-form-item>
                            </div>
                            <div class="addressItem">
                            <el-form-item prop="quId">
                                <el-select
                                v-model="formData.quId"
                                disabled
                                placeholder="请选择区"
                                @change="handleArea"
                                ref="selectQuChange"
                                >
                                <el-option
                                    v-for="(item, index) in areaList"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.adcode"
                                >
                                </el-option>
                                </el-select>
                            </el-form-item>
                            </div>
                            <div class="addressItem">
                            <el-form-item prop="jiedaoId">
                                <el-select
                                    disabled
                                    v-model="formData.jiedaoId"
                                    placeholder="请选择街道"
                                    @change="streetChange"
                                    ref="selectJiedaoChange"
                                >
                                <el-option
                                    v-for="(item, index) in streetList"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.adcode + index"
                                >
                                </el-option>
                                </el-select>
                            </el-form-item>
                            </div>
                            <div class="addressItem">
                                <el-form-item prop="shequId">
                                    <el-select
                                        disabled
                                        v-model="formData.shequId"
                                        placeholder="请选择社区"
                                        ref="selectShequChange"
                                        @change="handleCommunityChange"
                                    >
                                        <el-option
                                            v-for="item in communityList"
                                            :key="item.id"
                                            :label="item.address"
                                            :value="item.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                </div>
                            </div>
                            <el-form-item prop="address">
                                <input
                                    disabled
                                    v-model.trim="formData.address"
                                    id="tipinput"
                                    class="el-input__inner"
                                    @focus="getMap('tipinput')"
                                    placeholder="请输入关键字"
                                    autocomplete="off"
                                />
                            </el-form-item>
                            <div class="map_container">
                                <div id="container1" style="width: 100%; height: 200px"></div>
                            </div>
                        </div>
                    </div>
                    <div style="display: flex; margin-right: 10px">
                        <el-form-item label="监护人:">
                            <el-input
                                placeholder="请输入"
                                v-model="formData.guardian"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="联系方式:">
                            <el-input
                                placeholder="请输入"
                                v-model="formData.guardianTel"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="与老人关系:">
                            <el-select v-model="formData.guardianRelationship">
                                <el-option
                                v-for="(item, index) in oldList"
                                :key="index"
                                :label="item.serviceName"
                                :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div
                        style="display: flex; margin-right: 10px"
                        v-for="(item, index) in formData.emergencyContactList"
                        :key="index"
                    >
                        <el-form-item label="紧急联系人:">
                            <el-input placeholder="请输入" v-model="item.name"></el-input>
                        </el-form-item>
                        <el-form-item label="联系方式:">
                            <el-input placeholder="请输入" v-model="item.phone"></el-input>
                        </el-form-item>
                        <el-form-item label="与老人关系:">
                            <el-select placeholder="请选择" v-model="item.relationship">
                                <el-option
                                v-for="(item, index) in oldList"
                                :key="index"
                                :label="item.serviceName"
                                :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <el-form-item label="身份证:" prop="imgURL1">
                        <div style="display: flex">
                            <div>
                                <el-upload
                                class="avatar-uploader"
                                :action="actionUrl"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess1"
                                :before-upload="beforeAvatarUpload"
                                >
                                <img
                                    v-if="formData.idJust"
                                    :src="formData.idJust"
                                    class="avatar"
                                />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                                <el-button style="margin-left: 30px" type="primary"
                                >身份证(正面)
                                </el-button>
                            </div>
                            <div style="margin-left: 10%">
                                <el-upload
                                class="avatar-uploader"
                                :action="actionUrl"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess2"
                                :before-upload="beforeAvatarUpload"
                                >
                                <img
                                    v-if="formData.idBack"
                                    :src="formData.idBack"
                                    class="avatar"
                                />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                                <el-button style="margin-left: 30px" type="primary"
                                >身份证(反面)
                                </el-button>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="户口本:" prop="imgURL3">
                        <div style="display: flex">
                            <div>
                                <el-upload
                                class="avatar-uploader"
                                :action="actionUrl"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess3"
                                :before-upload="beforeAvatarUpload"
                                >
                                <img
                                    v-if="formData.hkbHome"
                                    :src="formData.hkbHome"
                                    class="avatar"
                                />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                                <el-button style="margin-left: 30px" type="primary"
                                >户口本(首页)
                                </el-button>
                            </div>
                            <div style="margin-left: 10%">
                                <el-upload
                                class="avatar-uploader"
                                :action="actionUrl"
                                :show-file-list="false"
                                :on-success="handleAvatarSuccess4"
                                :before-upload="beforeAvatarUpload"
                                >
                                <img
                                    v-if="formData.hkbOneself"
                                    :src="formData.hkbOneself"
                                    class="avatar"
                                />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                                <el-button style="margin-left: 30px" type="primary"
                                >户口本(末页)
                                </el-button>
                            </div>
                        </div>
                    </el-form-item>
                </div>
                <div v-show="controlAddContent == 2">
                    <div style="color: #00a1ff">入院信息</div>
                    <hr />
                    <div style="display: flex">
                    <div>
                        <el-form-item label="入院时间:" prop="intoTime">
                        <el-date-picker
                            value-format="yyyy-MM-dd HH:mm:ss"
                            style="width: 200px"
                            type="datetime"
                            v-model="formData.intoTime"
                            placeholder="选择时间"
                        >
                        </el-date-picker>
                        </el-form-item>
                        <el-form-item
                        label="试住终止日期:"
                        prop="intoTypeTime"
                        v-if="this.formData.intoType == '1'"
                        >
                        <el-date-picker
                            v-model="formData.intoTypeTime"
                            style="width: 200px"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择时间"
                        >
                        </el-date-picker>
                        </el-form-item>
                        <el-form-item
                        label="试住终止日期:"
                        v-if="
                            this.formData.intoType == '0' ||
                            this.formData.intoType == ''
                        "
                        >
                        <el-date-picker
                            v-model="formData.intoTypeTime"
                            style="width: 200px"
                            type="datetime"
                            disabled
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择时间"
                        >
                        </el-date-picker>
                        </el-form-item>
                        <el-form-item label="到期时间:" prop="expireTime">
                        <el-date-picker
                            value-format="yyyy-MM-dd HH:mm:ss"
                            v-model="formData.expireTime"
                            style="width: 200px"
                            type="datetime"
                            placeholder="选择时间"
                        >
                        </el-date-picker>
                        </el-form-item>

                        <el-form-item label="楼栋选择:" prop="storey">
                        <el-select
                            v-model="formData.houseName"
                            placeholder="请选择"
                            style="width: 200px"
                        >
                            <el-option
                            v-for="(item, index) in buildingList"
                            :key="index"
                            :label="item.name"
                            :value="item.uid"
                            ></el-option>
                        </el-select>
                        </el-form-item>
                        <el-form-item label="楼层选择:">
                        <el-select
                            v-model="formData.storeyName"
                            placeholder="请选择"
                            style="width: 200px"
                        >
                            <el-option
                            v-for="(item, index) in floorSelectionList"
                            :key="index"
                            :label="item.name"
                            :value="item.uid"
                            ></el-option>
                        </el-select>
                        </el-form-item>
                        <el-form-item label="入院床位:" prop="bedId">
                        <el-select
                            v-model="formData.bedId"
                            placeholder="请选择"
                            style="width: 200px"
                        >
                            <el-option
                            v-for="(item, index) in bedList"
                            :key="index"
                            :label="item.bedName"
                            :value="item.bedId"
                            ></el-option>
                        </el-select>
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item label="有无试住:" prop="intoType">
                        <el-select
                            placeholder="请选择"
                            style="width: 200px"
                            v-model="formData.intoType"
                        >
                            <el-option value="0" label="无"></el-option>
                            <el-option value="1" label="有"></el-option>
                        </el-select>
                        </el-form-item>
                        <el-form-item label="计费开始日期:" prop="chargingTime">
                        <el-date-picker
                            type="datetime"
                            style="width: 200px"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            v-model="formData.chargingTime"
                            placeholder="选择时间"
                        >
                        </el-date-picker>
                        </el-form-item>
                        <el-form-item label="外出方式:" prop="outType">
                        <el-select
                            placeholder="请选择"
                            style="width: 200px"
                            v-model="formData.outType"
                        >
                            <el-option :value="0" label="自由出入"></el-option>
                            <el-option :value="1" label="需家人同意"></el-option>
                            <el-option :value="2" label="其他"></el-option>
                        </el-select>
                        </el-form-item>

                        <el-form-item label="单元选择:">
                        <el-select
                            v-model="formData.unitName"
                            placeholder="请选择"
                            style="width: 200px"
                        >
                            <el-option
                            v-for="(item, index) in selectionList"
                            :key="index"
                            :label="item.name"
                            :value="item.uid"
                            ></el-option>
                        </el-select>
                        </el-form-item>
                        <el-form-item label="房间选择:">
                        <el-select
                            v-model="formData.roomName"
                            placeholder="请选择"
                            style="width: 200px"
                        >
                            <el-option
                            v-for="(item, index) in roomSelectionList"
                            :key="index"
                            :label="item.roomName"
                            :value="item.id"
                            ></el-option>
                        </el-select>
                        </el-form-item>
                    </div>
                    </div>
                    <div style="color: #00a1ff">入院费用</div>
                    <hr />
                    <div style="display: flex">
                    <div>
                        <el-form-item label="护理床位等级:" prop="bedLevelId">
                            <el-input v-model="formData.bedLevelName"></el-input>
                        </el-form-item>
                        <el-form-item label="电费:">
                        <el-input
                            placeholder="请输入"
                            v-model="formData.electricityFees"
                            onkeyup="this.value=this.value.match(/\d+\.?\d{0,2}/);this.dispatchEvent(new Event('input'))"
                        >
                            <i slot="suffix">元/月</i>
                        </el-input>
                        </el-form-item>
                        <el-form-item label="餐饮类别:" prop="restaurant">
                            <el-input v-model="formData.restaurantName"></el-input>
                        </el-form-item>
                        <el-form-item label="基础服务:" prop="service">
                            <el-input v-model="formData.serviceName"></el-input>
                        </el-form-item>
                        <el-form-item label="月度费用总计:">
                        <el-input
                            placeholder="请输入"
                            v-model="formData.monthlyCost"
                            disabled
                            onkeyup="this.value=this.value.match(/\d+\.?\d{0,2}/);this.dispatchEvent(new Event('input'))"
                        >
                            <i slot="suffix">元</i>
                        </el-input>
                        </el-form-item>
                        <el-form-item label="本次应收:" prop="receivable">
                        <el-input
                            placeholder="请输入"
                            disabled
                            v-model="formData.receivable"
                            onkeyup="this.value=this.value.match(/\d+\.?\d{0,2}/);this.dispatchEvent(new Event('input'))"
                        >
                            <i slot="suffix">元</i>
                        </el-input>
                        </el-form-item>
                        <el-form-item label="付款方式" prop="paymentMethod">
                        <el-select v-model="formData.paymentMethod">
                            <el-option value="1" label="现金"></el-option>
                            <el-option value="2" label="微信"></el-option>
                            <el-option value="3" label="支付宝"></el-option>
                        </el-select>
                        </el-form-item>
                    </div>
                    <div>
                        <el-form-item label="护理费:" prop="nursingExpenses">
                        <el-input
                            placeholder="请输入"
                            v-model="formData.nursingExpenses"
                            onkeyup="this.value=this.value.match(/\d+\.?\d{0,2}/);this.dispatchEvent(new Event('input'))"
                        >
                            <i slot="suffix">元/月</i>
                        </el-input>
                        </el-form-item>
                        <el-form-item label="水费:">
                        <el-input
                            placeholder="请输入"
                            v-model="formData.chargeForWater"
                            onkeyup="this.value=this.value.match(/\d+\.?\d{0,2}/);this.dispatchEvent(new Event('input'))"
                        >
                            <i slot="suffix">元/月</i>
                        </el-input>
                        </el-form-item>
                        <el-form-item label="餐饮费用:">
                        <el-input
                            placeholder="请输入"
                            v-model="formData.restaurantCost"
                            onkeyup="this.value=this.value.match(/\d+\.?\d{0,2}/);this.dispatchEvent(new Event('input'))"
                        >
                            <i slot="suffix">元/月</i>
                        </el-input>
                        </el-form-item>
                        <el-form-item label="服务费:">
                        <el-input
                            placeholder="请输入"
                            v-model="formData.serviceCost"
                            @input="onInput()"
                            onkeyup="this.value=this.value.match(/\d+\.?\d{0,2}/);this.dispatchEvent(new Event('input'))"
                        >
                            <i slot="suffix">元/月</i>
                        </el-input>
                        </el-form-item>
                        <el-form-item label="押金:" prop="deposit">
                        <el-input
                            placeholder="请输入"
                            v-model="formData.deposit"
                            onkeyup="this.value=this.value.match(/\d+\.?\d{0,2}/);this.dispatchEvent(new Event('input'))"
                        >
                            <i slot="suffix">元</i>
                        </el-input>
                        </el-form-item>
                        <el-form-item label="本次实收:" prop="netreceipts">
                        <el-input
                            placeholder="请输入"
                            v-model="formData.netreceipts"
                            disabled
                            type="number"
                            min="0"
                        >
                            <i slot="suffix">元</i>
                        </el-input>
                        </el-form-item>
                        <div style="width: 100%">
                        <img
                            src="./../assets/img/QRCode.png"
                            v-if="
                            this.formData.paymentMethod == 3 ||
                            this.formData.paymentMethod == 2
                            "
                        />
                        </div>
                    </div>
                    </div>
                    <div style="color: #00a1ff">提醒信息</div>
                    <hr />
                    <el-form-item label="事件提醒:">
                    <el-button
                        type="success"
                        icon="iconfont icon-xinzeng"
                        size="mini"
                        @click="submint('新增')"
                        >新增
                    </el-button>
                    <div style="width: 100%; margin-top: 10px">
                        <el-table
                        border
                        style="width: 100%"
                        :data="formData.matterList"
                        >
                        <el-table-column
                            align="center"
                            width="70"
                            type="index"
                            label="序号"
                        ></el-table-column>
                        <el-table-column
                            align="center"
                            prop="remindName"
                            label="事件类型提醒"
                        >
                        </el-table-column>
                        <el-table-column
                            align="center"
                            prop="way"
                            label="事件提醒方式"
                        >
                            <template slot-scope="scope">
                            <span v-if="scope.row.way == 0">电话</span>
                            <span v-if="scope.row.way == 1">短信</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            align="center"
                            prop="eventEay"
                            label="时间方式选择"
                        >
                            <template slot-scope="scope">
                            <span v-if="scope.row.eventEay == 0">固定</span>
                            <span v-if="scope.row.eventEay == 1">常态</span>
                            <span v-if="scope.row.eventEay == 2">特殊</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="操作">
                            <template slot-scope="scope">
                                <el-link
                                    :underline="false"
                                    disabled
                                    @click="submint('查看', scope.row)"
                                    >查看
                                </el-link>
                            </template>
                        </el-table-column>
                        </el-table>
                    </div>
                    </el-form-item>
                </div>
                <div v-show="controlAddContent == 3">
                <el-form
                    label-width="110px"
                    disabled
                    :model="formData"
                >
                    <el-form-item label="饮食禁忌:" prop="dietTaboo">
                    <el-checkbox-group v-model="formData.dietTaboo">
                        <el-checkbox :label="0" value="0">糖 </el-checkbox>
                        <el-checkbox :label="1" value="1">海鲜 </el-checkbox>
                        <el-checkbox :label="2" value="2">蛋类 </el-checkbox>
                        <el-checkbox :label="3" value="3">豆制品 </el-checkbox>
                        <el-checkbox :label="4" value="4">其他 </el-checkbox>
                    </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="自理情况:" prop="selfCare">
                    <el-checkbox-group
                        v-model="formData.selfCare"
                        :max="1"
                    >
                        <el-checkbox :label="0" value="0"
                        >较差，完全需要别人照顾
                        </el-checkbox>
                        <el-checkbox :label="1" value="1"
                        >一般，有些事情需要别人照顾
                        </el-checkbox>
                        <el-checkbox :label="2" value="2"
                        >较好，一般不需要别人照顾
                        </el-checkbox>
                        <el-checkbox :label="3" value="3"
                        >很好，还可以照顾别人
                        </el-checkbox>
                    </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="健康情况:" prop="health">
                    <el-checkbox-group v-model="formData.health">
                        <el-checkbox :label="0" value="0">身体健康 </el-checkbox>
                        <el-checkbox :label="1" value="1">高血压 </el-checkbox>
                        <el-checkbox :label="2" value="2">冠心病 </el-checkbox>
                        <el-checkbox :label="3" value="3">脑卒中 </el-checkbox>
                        <br />
                        <el-checkbox :label="4" value="4">糖尿病 </el-checkbox>
                        <el-checkbox :label="5" value="5">类风湿 </el-checkbox>
                        <el-checkbox :label="6" value="6">脑出血 </el-checkbox>
                        <el-checkbox :label="7" value="7">高血脂 </el-checkbox>
                        <br />
                        <el-checkbox :label="8" value="8">系统性狼疮 </el-checkbox>
                        <el-checkbox :label="9" value="9">恶性肿瘤 </el-checkbox>
                        <el-checkbox :label="10" value="10">重性精神病 </el-checkbox>
                        <el-checkbox :label="11" value="11">结核病 </el-checkbox>
                        <br />
                        <el-checkbox :label="12" value="12">肝炎 </el-checkbox>
                        <el-checkbox :label="13" value="13"
                        >其他法定传染病
                        </el-checkbox>
                        <el-checkbox :label="14" value="14">其他 </el-checkbox>
                    </el-checkbox-group>
                    </el-form-item>
                    <el-form-item
                    label="药物过敏:"
                    prop="drugAllergy"
                    style="margin-top: 20px"
                    >
                    <el-select style="width: 100%" v-model="formData.drugAllergy">
                        <el-option value="0" label="否"></el-option>
                        <el-option value="1" label="是"></el-option>
                    </el-select>
                    <el-select
                        v-model="drugs"
                        multiple
                        v-if="formData.drugAllergy == 1"
                        style="width: 100%; margin-top: 20px"
                        placeholder="请选择过敏药品"
                    >
                        <el-option
                        v-for="(item, index) in drugsList"
                        :key="index"
                        :label="item.serviceName"
                        :value="item.id"
                        ></el-option>
                    </el-select>
                    </el-form-item>
                    <el-form-item label="备注:">
                    <el-input type="textarea" v-model="formData.remarks"></el-input>
                    </el-form-item>
                    <div class="item-title">医嘱信息</div>
                    <el-button
                        type="success"
                        disabled
                        @click="oldDoctorModal('新增')"
                    >新 增</el-button
                    >
                    <div style="margin-top: 15px">
                    <el-table
                        :data="formData.oldDoctorOrderList"
                        border
                        style="width: 100%"
                    >
                        <el-table-column
                            type="index"
                            width="70"
                            label="序号"
                            align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="date"
                            label="日期"
                            :show-overflow-tooltip="true"
                            align="center"
                        >
                        <template slot-scope="scope">
                            {{
                            scope.row.orderStartTime + "至" + scope.row.orderEndTime
                            }}
                        </template>
                        </el-table-column>
                        <el-table-column
                            prop="nursinglevelName"
                            label="护理级别"
                            align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="attendingPhysicianName"
                            align="center"
                            :show-overflow-tooltip="true"
                            label="医师"
                        >
                        </el-table-column>
                        <el-table-column
                            fixed="right"
                            prop="operation"
                            label="操作"
                            align="center"
                            width="140px"
                        >
                        <template slot-scope="scope">
                            <el-button
                                 disabled
                                @click="oldDoctorModal('查看', scope.row)"
                                type="text"
                            >查看</el-button
                            >
                            <el-button disabled @click="oldDoctorDel(scope.row)" type="text"
                            >删除</el-button
                            >
                        </template>
                        </el-table-column>
                    </el-table>
                    </div>
                    <div class="item-title">用药管理</div>
                    <el-button type="success" @click="customerMedicationModal('新增')"
                    >新 增</el-button
                    >
                    <div style="margin-top: 15px">
                    <el-table
                        :data="formData.customerMedicationList"
                        border
                        style="width: 100%"
                    >
                        <el-table-column
                            type="index"
                            width="70"
                            label="序号"
                            align="center"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="doctorOrderType"
                            label="医嘱"
                            :show-overflow-tooltip="true"
                            align="center"
                        >
                        <template slot-scope="scope">
                            {{ scope.row.doctorOrderType === 1 ? "长嘱" : "临嘱" }}
                        </template>
                        </el-table-column>
                        <el-table-column prop="typesOf" label="类型" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.typesOf === 0">药物</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                            prop="orderStartTime"
                            align="center"
                            :show-overflow-tooltip="true"
                            label="开医嘱时间"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="orderEndTime"
                            align="center"
                            :show-overflow-tooltip="true"
                            label="停医嘱时间"
                        >
                        </el-table-column>
                        <el-table-column
                            fixed="right"
                            prop="operation"
                            label="操作"
                            align="center"
                            width="140px"
                        >
                        <template slot-scope="scope">
                            <el-button
                                disabled
                                @click="customerMedicationModal('查看', scope.row)"
                                type="text"
                            >查看</el-button
                            >
                            <el-button
                                disabled
                                @click="customerMedicationDel(scope.row)"
                                type="text"
                            >删除</el-button
                            >
                        </template>
                        </el-table-column>
                    </el-table>
                    </div>
                </el-form>
                </div>
                <div v-show="controlAddContent == 4">
                    <el-form-item label="上传合同:" style="margin-top: 20px">
                        <el-upload
                            class="upload-demo"
                            :action="actionUrl"
                            :show-file-list="false"
                            multiple
                        >
                        <el-button class="editcss" type="primary">上传</el-button>
                        </el-upload>
                            <div v-for="(item, index) in formData.contract" :key="index">
                            <el-link :href="item.name" target="_blank">{{ item.img }}</el-link
                            ><button
                                v-if="item.img"
                                disabled
                                class="iconfont icon-icon7 tabBtn"
                                @click="deleteId(index)"
                            ></button>
                        </div>
                    </el-form-item>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import baseURL from "@/api/baseURL"
export default {
    props: ["openData"],
    data(){
        return{
            controlAddContent:1,
            personnelTypeList:[],
            normalInfo:{},
            provinceList: [], //
            cityList: [],
            areaList: [],
            streetList: [],
            polygons: [],
            communityList: [],
            oldList:[],
            buildingList:[],
            actionUrl:"",
            titleList:[
                {
                    id: "1",
                    name: "基本信息",
                },
                {
                    id: "2",
                    name: "入院信息",
                },
                {
                    id: "3",
                    name: "健康信息",
                },
                {
                    id: "4",
                    name: "生成合同",
                },
            ],
            formData:{
                contract:[],
                name: "", //姓名
                gender: "", //性别
                portraitImg: "", //头像
                birth: "", //出生年月日
                phone: "", //手机号码
                personType: "",
                shengId: null, //省
                shiId: null, //市
                quId: null, //区/县
                jiedaoId: null, //街道
                shequId: null, //社区
                address: "", //详细地址
                guardian: "", //
                guardianTel: "", //联系方式
                guardianRelationship: "", //与老人关系
                emergencyContact: "",
                emergencyContactInformation: "",
                //紧急联系人
                emergencyContactList: [
                {
                    name: "",
                    phone: "",
                    relationship: "",
                },
                ],
                oldDoctorOrderLis:[],
                customerMedicationList:[],
                matterList: [],
                longitude: "", //经度
                latitude: "", //纬度
                intoTime: "", //入院时间
                outType: "", //外出方式
                expireTime: "", //到期时间
                intoType: "", // 是否试住
                storey: "", //楼层选择
                intoTypeTime: "", // 试住终止日期
                chargingTime: "", //计费开始日期
                bed: "", //入住床位
                bedLevelId: "", //护理床位等级
                electricityFees: "", //电费
                nursingExpenses: "", //护理费
                serviceCost: "",
                chargeForWater: "", //水费
                restaurant: "", //餐饮类别
                restaurantCost: "", //餐饮费用
                remarks: "", // 备注
                service: "", //基础服务
                monthlyCost: "", //月度费用总计
                receivable: "", //本次应收
                netreceipts: "", //本次实收
                paymentMethod: "", //付款方式
                deposit: "", //押金
                dietTaboo: [], //饮食禁忌
                selfCare: [], //自理情况
                health: [], //健康情况
                drugAllergy: "", //是否过敏
                roomName:"",
            },
            serviceList:[],
            floorSelectionList:[],
            bedList:[],
            selectionList:[],
            roomSelectionList:[],
            bedLevelList:[],
            restaurantList:[],
            drugs:[],
            drugsList:[],
        }
    },
    created(){
        this.actionUrl =
            baseURL + "/ypt/controller/uploadController/info/uploadPhoto"
        this.getOrg()
        this.getPersonnelTypeList()
        this.getRestaurantList()
        this.getServiceList()
        this.dataEcho()
        this.getDrugsTypeList()
        setTimeout(async () => {
            await this.$nextTick(() => this.loadMap())
        }, 30)
    },
    methods:{
        dataEcho(){
            this.$http.request({
                url:"/jgyl/admin/register/info/get",
                method:"POST",
                data:{
                    id: this.openData.id,
                }
            }).then(async (res) => {
                if(res.code == 200){
                    if(res.content != null){
                        if (res.content.dietTaboo) {
                            res.content.dietTaboo = JSON.parse(res.content.dietTaboo)
                        }
                        if (res.content.health) {
                            res.content.health = JSON.parse(res.content.health)
                        }
                        if (res.content.selfCare) {
                            res.content.selfCare = JSON.parse(res.content.selfCare)
                        }
                        const content = res.content
                        if (content.shengId) {
                            content.shengId = String(content.shengId)
                        }
                        if (content.shiId) {
                            content.shiId = String(content.shiId)
                        }
                        if (content.quId) {
                            content.quId = String(content.quId)
                        }
                        if (content.jiedaoId) {
                            content.jiedaoId = String(content.jiedaoId)
                        }
                        if (content.shequId) {
                            content.shequId = String(content.shequId)
                        }
                        this.formData = res.content
                        if (!this.formData.shengId) return
                        let city = await this.getDistrict(this.formData.shengId)
                        this.cityList = city.districtList
                        if (!this.formData.shiId) return
                        let area = await this.getDistrict(this.formData.shiId)
                        this.areaList = area.districtList
                        if (!this.formData.quId) return
                        let street = await this.getDistrict(this.formData.quId)
                        this.streetList = street.districtList
                        if (!this.formData.jiedaoId) return
                        let communityList = await this.getCommityList(
                        this.formData.jiedaoId
                        )
                        this.communityList = communityList
                        this.drugs = res.content.drugs.split(",").map(Number)
                        setTimeout(async () => {
                            await this.$nextTick(() => {
                                this.loadMap("container")
                                this.potintMap()
                            })
                        }, 30)
                        if (this.formData.contract) {
                            this.formData.contract = this.formData.contract.split(",")
                            let aa = []
                            res.content.contract.forEach((item, index) => {
                                if (item != "?") {
                                aa.push({
                                    name: item.substring(0, item.lastIndexOf("?")),
                                    img: item.substring(item.lastIndexOf("?") + 1),
                                })
                                }
                            })
                            this.formData.contract = aa
                        }
                    }
                }
            })
        },
        dialogVisibleClone(){
            this.$emit("cancleService", false)
        },
        changeIdx(id) {
            this.controlAddContent = id
        },
        // 上传图片
        handleAvatarSuccess(res, file) {
            this.$set(this.formData, "portraitImg", res.content)
        },
        handleAvatarSuccess1(res, file) {
            this.$set(this.formData, "idJust", res.content)
        },
        handleAvatarSuccess2(res, file) {
            this.$set(this.formData, "idBack", res.content)
        },
        handleAvatarSuccess3(res, file) {
            this.$set(this.formData, "hkbHome", res.content)
        },
        handleAvatarSuccess4(res, file) {
            this.$set(this.formData, "hkbOneself", res.content)
        },
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 2MB!")
            }
            return isLt2M
        },
        //老人类型
        getPersonnelTypeList() {
            this.$http
                .request({
                url: "/jgyl/admin/dataSettings/info/findList",
                method: "POST",
                data: {
                    pageNo: 1,
                    pageSize: -1,
                    type: "0",
                    state: 1,
                },
                })
                .then((res) => {
                if (res.code == 200) {
                    // if (res.content == null || res.content == "null") {
                    //     this.personnelTypeList = []
                    //     return
                    // }
                    this.personnelTypeList = res.content.list.map((item) => {
                        return {
                            personType: item.id,
                            personTypeName: item.typeName,
                        }
                    })
                }
            })
        },
        //餐饮类别
        getRestaurantList() {
            this.$http
                .request({
                url: "/jgyl/admin/dataSettings/info/findList",
                method: "POST",
                data: {
                    pageNo: 1,
                    pageSize: 1000,
                    type: "2",
                    state: 1,
                },
                })
                .then((res) => {
                if (res.code == 200) {
                    if (res.content == null || res.content == "null") {
                    return
                    }
                    this.restaurantList = res.content.list.map((item) => {
                    return {
                        typeNameId: item.id, //id
                        typeName: item.typeName,
                    }
                    })
                }
            })
        },
        //基础类别
        getServiceList() {
            this.$http
                .request({
                url: "/jgyl/admin/dataSettings/info/findList",
                method: "POST",
                data: {
                    pageNo: 1,
                    pageSize: 1000,
                    type: "3",
                    state: 1,
                },
                })
                .then((res) => {
                if (res.code == 200) {
                    if (res.content == null || res.content == "null") {
                    return
                    }
                    this.serviceList = res.content.list.map((item) => {
                    return {
                        typeNameId: item.id, //id
                        typeName: item.typeName,
                    }
                    })
                }
            })
        },
        //药品
        getDrugsTypeList() {
            this.$http
                .request({
                url: "/jgyl/admin/serviceName/info/findList",
                method: "POST",
                data: {
                    pageNo: 1,
                    pageSize: 1000,
                    type: "5",
                    state: 1,
                },
                })
                .then((res) => {
                if (res.code == 200) {
                    if (res.content == null || res.content == "null") {
                    return
                    }
                    this.drugsList = res.content.list
                }
            })
        },
        loadMap() {
            //地图加载
            return new Promise((resolve, reject) => {
                this.myMap = new AMap.Map("container1", {
                    resizeEnable: true,
                    zoom: 8,
                })
                resolve()
            })
        },
        // 五级联动地图方法
        //获取省级
        async getProvince() {
            this.provinceLis = []
            this.cityList = []
            this.areaList = []
            this.streetList = []
            let province = await this.getDistrict()
            this.provinceList = province.districtList
        },
        //  省级地址选择发生改变
        async handleProvince(val) {
            this.cityList = []
            this.areaList = []
            this.streetList = []
            this.communityList = []
            this.formData.shiId = ""
            this.formData.quId = ""
            this.formData.jiedaoId = ""
            this.formData.shequId = ""
            this.formData.address = ""
            let city = await this.getDistrict(val)
            this.cityList = city.districtList
            this.joinAddress()
        },
        //市级地址发生改变
        async handleCity(val) {
            this.areaList = []
            this.streetList = []
            this.communityList = []
            this.formData.quId = ""
            this.formData.jiedaoId = ""
            this.formData.shequId = ""
            this.formData.address = ""
            let area = await this.getDistrict(val)
            this.areaList = area.districtList
            this.joinAddress()
        },
        //县区级地址发生改变
        async handleArea(val) {
            this.streetList = []
            this.communityList = []
            this.formData.jiedaoId = ""
            this.formData.shequId = ""
            this.formData.address = ""
            // val = val.replace(/.$/, "");
            let street = await this.getDistrict(val)
            this.streetList = street.districtList
            this.joinAddress()
        },

        //获取地址
        getDistrict(name = "中国", params = null) {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                subdistrict: 1, //返回下一级行政区
                extensions: "all",
                showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                let geocoder = new AMap.Geocoder({
                city: "", //城市设为北京，默认：“全国”
                radius: 1000, //范围，默认：500
                })
                try {
                const MarkerList = self.myMap
                    .getAllOverlays()
                    .filter((item) => item.CLASS_NAME === "AMap.Marker")
                self.myMap.remove(MarkerList)
                self.myMap.remove(self.marker)
                } catch (err) {}
                self.marker = new AMap.Marker()
                district.search(name, (status, result) => {
                if (status == "complete") {
                    resolve(result.districtList[0])
                    if (this.isMap) {
                    this.isMap = false
                    return
                    }
                    let bounds = result.districtList[0].boundaries
                    self.polygon = null
                    if (bounds) {
                    self.myMap.remove(self.polygons)
                    self.polygons = []
                    for (let i = 0, l = bounds.length; i < l; i++) {
                        self.polygon = new AMap.Polygon({
                        map: self.myMap,
                        strokeWeight: 1,
                        strokeColor: "#0091ea",
                        fillColor: "#80d8ff",
                        fillOpacity: 0.4,
                        path: bounds[i],
                        })
                        self.polygons.push(self.polygon)
                        if (!params) {
                        self.polygon.on("click", function (e) {
                            let lnglat = e.lnglat
                            self.myMap.add(self.marker)
                            self.marker.setPosition(lnglat)
                            geocoder.getAddress(lnglat, function (status, result) {
                            if (status === "complete" && result.regeocode) {
                                var address = result.regeocode.formattedAddress
                                self.formData.address = address
                                self.formData.longitude = lnglat.lng
                                self.formData.latitude = lnglat.lat
                            } else {
                                console.error("根据经纬度查询地址失败")
                            }
                            })
                        })

                        self.myMap.add(self.polygons)

                        self.myMap.add(self.marker)
                        self.marker.setPosition([
                            result.districtList[0].center.lng,
                            result.districtList[0].center.lat,
                        ])
                        self.myMap.setFitView(self.marker)
                        self.myMap.setZoom(11)
                        self.myMap.setFitView() //地图自适应
                        } else {
                        if (params.longitude && params.latitude) {
                            self.myMap.add(self.marker)
                            self.marker.setPosition([params.longitude, params.latitude])
                            self.myMap.setFitView(self.marker)
                            self.myMap.setZoom(11)
                        }
                    }
                }
                }
            }
            })
          }).catch((err) => {})
        },
        // 社区地址列表
        getCommityList(val) {
            let self = this
            return new Promise((resolve, reject) => {
                self.$http
                .request({
                    url: "/ypt/admin/standardAddress/info/StandardAddressTree",
                    method: "POST",
                    data: {
                    jiedaoId: val,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                    if (!res.content) {
                        resolve([])
                        return
                    }
                    resolve(res.content)
                    } else {
                    resolve([])
                    }
                })
            }).catch((err) => {})
        },
        //街道地址发生变化
        async streetChange(val) {
            let communityList = await this.getCommityList(val)
            this.communityList = communityList
            this.joinAddress()
        },
        handleCommunityChange(val) {
            this.$nextTick(() => {
                this.$forceUpdate()
                this.joinAddress()
            })
        },
         // 打点
        potintMap() {
            const self = this
            try {
                self.myMap.remove(self.marker)
            } catch (err) {}
            self.marker = new AMap.Marker({
                icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
                position: [
                Number(self.formData.longitude),
                Number(self.formData.latitude),
                ],
            })
            self.myMap.add(self.marker)
            self.myMap.setFitView()
        },
        //获取组织机构
        getOrg() {
            this.$http
                .request({
                url: "/rbac/admin/org/info/findOrgById",
                method: "POST",
                data: { id: this.$store.state.info.orgId },
                })
                .then((res) => {
                if (res.code == 200) {
                    // this.getProvince()
                    this.normalInfo = res.content
                    this.changeFirst()
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        async changeFirst() {
            let province = await this.getDistricts()
            this.provinceList = province.districtList
            if (this.normalInfo.provinceId == 0) {
                this.normalInfo.provinceId = ""
            } else {
                this.normalInfo.provinceId = String(this.normalInfo.provinceId)
                let cityList = await this.getDistricts(this.normalInfo.provinceId)
                this.cityList = cityList.districtList
            }
            if (this.normalInfo.cityId) {
                this.normalInfo.cityId = String(this.normalInfo.cityId)
                let areaList = await this.getDistricts(this.normalInfo.cityId)
                this.areaList = areaList.districtList
            } else {
                this.normalInfo.cityId = ""
            }

            if (this.normalInfo.areaId) {
                this.normalInfo.areaId = String(this.normalInfo.areaId)
                let streetList = await this.getDistricts(this.normalInfo.areaId)
                this.streetList = streetList.districtList
            } else {
                this.normalInfo.areaId = ""
            }
            if (this.normalInfo.streetId) {
                this.normalInfo.streetId = String(this.normalInfo.streetId)
                let communityList = await this.getCommityList(this.normalInfo.streetId)
                this.communityList = communityList
            } else {
                this.normalInfo.streetId = ""
            }
            if (this.normalInfo.orgLevel == 1 || this.normalInfo.orgLevel == 0) {
                this.provinceList.forEach((item) => {
                if (item.adcode == this.normalInfo.provinceId) {
                    this.formData.latitude = item.center.lat
                    this.formData.longitude = item.center.lng
                }
                })
            } else if (this.normalInfo.orgLevel == 2) {
                this.cityList.forEach((item) => {
                if (item.adcode == this.normalInfo.cityId) {
                    this.formData.latitude = item.center.lat
                    this.formData.longitude = item.center.lng
                }
                })
            } else if (this.normalInfo.orgLevel == 3) {
                this.areaList.forEach((item) => {
                if (item.adcode == this.normalInfo.areaId) {
                    this.formData.latitude = item.center.lat
                    this.formData.longitude = item.center.lng
                }
                })
            } else if (
                this.normalInfo.orgLevel == 4 ||
                this.normalInfo.orgLevel == 5
            ) {
                this.streetList.forEach((item, index) => {
                if (item.adcode + index == this.normalInfo.streetId) {
                    this.formData.latitude = item.center.lat
                    this.formData.longitude = item.center.lng
                }
                })
            }

            if (this.normalInfo.communityId) {
                this.normalInfo.communityId = Number(this.normalInfo.communityId)
            } else {
                this.normalInfo.communityId = ""
            }

            this.formData.shengId = this.normalInfo.provinceId
            this.formData.shiId = this.normalInfo.cityId
            this.formData.quId = this.normalInfo.areaId
            this.formData.jiedaoId = this.normalInfo.streetId
            this.formData.shequId = this.normalInfo.communityId
            setTimeout(async () => {
                await this.$nextTick(() => {
                this.loadMap("container")
                this.potintMap()
                })
            }, 30)
            this.$forceUpdate()
        },
        //获取地址
        getDistricts(name = "中国", params = null) {
            let self = this
            return new Promise((resolve, reject) => {
                var opts = {
                subdistrict: 1, //返回下一级行政区
                extensions: "all",
                showbiz: false, //最后一级返回街道信息
                }
                let district = new AMap.DistrictSearch(opts)
                let geocoder = new AMap.Geocoder({
                city: "", //城市设为北京，默认：“全国”
                radius: 1000, //范围，默认：500
                })
                try {
                self.myMap.remove(self.marker)
                } catch (err) {}

                self.marker = new AMap.Marker()
                district.search(name, (status, result) => {
                if (status == "complete") {
                    resolve(result.districtList[0])
                    if (this.isMap) {
                    this.isMap = false
                    return
                    }
                    let bounds = result.districtList[0].boundaries
                    self.polygon = null
                }
                })
            }).catch((err) => {})
        },
    }
}
</script>

<style lang="less" scoped>
.name-per {
  width: 90%;
  margin: 0 auto;
  display: flex;
  margin-top: 10px;
}

.name-list {
  width: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
}

.name-list > div:first-child {
  width: 100%;
}

.name-title {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.name-title > div:first-child {
  width: 50%;
  height: 2px;
  background-color: #eeeeee;
}

.name-title > div:last-child {
  width: 50%;
  height: 2px;
  background-color: #eeeeee;
}

.changeColor > div:first-child {
  background-color: #0000ff;
}

.changeColor > div:nth-child(2) {
  color: #0000ff;
}

.changeColor > div:last-child {
  background-color: #0000ff;
}

.name-bottom {
  text-align: center;
}
.elder_manage_title {
  position: relative;
  width: 100%;
  margin-bottom: 15px;

  &::after {
    position: absolute;
    left: 120px;
    right: 0;
    display: block;
    content: "";
    border-bottom: 1px solid #e4e7ed;
  }

  .title {
    box-sizing: border-box;
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #409eff;
    font-size: 14px;
    border: 1px solid #e4e7ed;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
    background: #ffffff;
  }
}
/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

/deep/ .avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.addressFrom {
  display: flex;
  margin-right: 10px;

  .addressTitle {
    text-align: right;
    vertical-align: middle;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;

    span {
      color: #f56c6c;
      margin-right: 4px;
    }
  }

  .addressContent {
    flex: 1;

    .addressBox {
      display: flex;

      .addressItem {
        flex: 1;

        /deep/ .el-form-item__content {
          margin-left: 0px !important;
        }

        /deep/ .el-select {
          width: 100% !important;
        }
      }
    }

    /deep/ .el-form-item__content {
      margin-left: 0px !important;
    }
  }
}
.item-title {
  color: #409eff;
  border-bottom: 1px solid #d9d9d9;
  padding-bottom: 15px;
  margin-top: 10px;
  margin-bottom: 15px;
}
</style>